// src/components/Landing/LoginNotice.js
import React, { useEffect, useRef } from 'react';
import './LoginNotice.css';

export function LoginNotice() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="notice" ref={sectionRef}>
      <div className="container">
        <div className="notice-inner reveal">
          <div className="notice-badge">Access Information</div>
          <h3 className="notice-title">Built for Ohio State students</h3>
          <p className="notice-text">
            Students enrolled in select courses can register with their university email.
            Executive Education participants may request access by emailing{' '}
            <a href="mailto:castillo.230@osu.edu">Prof. Castillo</a>.
            All visitors are welcome to browse our public learning materials.
          </p>
        </div>
      </div>
    </section>
  );
}
